import styles from './Html.module.scss'
import styled from 'styled-components'

import React from 'react'

import ClassNames from 'classnames'
import PropTypes from 'prop-types'

import ColorFinder from 'Utilities/ColorFinder'

import Typography from 'Atoms/Typography'

const propTypes = {
  html: PropTypes.string.isRequired,
}

const Html = ({ html, className }) => {
  const linkStyling = ColorFinder('action', null, null)
  const headerStyling = ColorFinder(null, 'subtle', null)

  return (
    <Typography as={'div'} size={1}>
      <StyledDangerousHtml
        dangerouslySetInnerHTML={{ __html: `${html}` }}
        className={ClassNames(styles.dangerousHtml, className)}
        linkStyling={linkStyling}
        headerStyling={headerStyling}
      />
    </Typography>
  )
}

const StyledDangerousHtml = styled.div`
  a {
    color: ${(props) => props.linkStyling.color};
    &:hover {
      color: ${(props) => props.linkStyling.hoverColor};
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.headerStyling.color};
  }
`

Html.propTypes = propTypes

export default Html
